
import { AuthProvider } from 'app/contexts/auth/Provider';
import { BreakpointProvider } from 'app/contexts/breakpoint/Provider';
import { LocaleProvider } from 'app/contexts/locale/Provider';
import { SidebarProvider } from 'app/contexts/sidebar/Provider';
import { ThemeProvider } from 'app/contexts/theme/Provider';
import { ClientThemeProvider } from 'contexts/ThemeContext';
import { MapProvider } from 'app/contexts/MapContext';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { RouterProvider } from 'react-router';
import { en, fr } from 'configs/i18n';
import { getSystemLanguage } from 'utils';
import { routerIndustrial, routerManager, routerMonitoring } from 'app/router';
import { useAppModule } from 'hooks/useAppModule';

const ROUTERS = {
  INDUSTRIAL: routerIndustrial,
  MONITORING: routerMonitoring,
  MANAGER: routerManager,
};

function App() {
  const { module } = useAppModule();
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: { en, fr },
      lng: getSystemLanguage(),
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });

  const router = ROUTERS[module] || routerIndustrial;

  return (
    <ClientThemeProvider>
      <AuthProvider>
        <ThemeProvider>
          <LocaleProvider>
            <BreakpointProvider>
              <SidebarProvider>
                <MapProvider>
                  <RouterProvider router={router} />
                </MapProvider>
              </SidebarProvider>
            </BreakpointProvider>
          </LocaleProvider>
        </ThemeProvider>
      </AuthProvider>
    </ClientThemeProvider>
  );
}

export default App;
